export enum Routing {
	PanelLogin = 'login',
	PanelForgotPassword = 'forgot-password',
	PanelForgotPasswordReset = 'forgot-password/reset',
	PanelRegister = 'register',
	PanelRegisterVerify = 'register/verify',
	PanelVerifyEmail = 'verify-email',
	PanelDashboard = 'dashboard',
	PanelCurrencyList = 'cryptocurrency/list',
	PanelCurrencyDetails = 'currency/details',
	PanelCurrencyAnalytics = 'currency/analytics',
	PanelAccountSettings = 'account/settings',
	PanelSecuritySettings = 'account/security',
	PanelTwoFactorSettings = 'account/2fa',
	PanelGdprSettings = 'account/privacy',
	PanelSentiment = 'sentiment',
	PanelVolume = 'volume',
	PanelVolumetric = 'volumetric',
	PanelLiquidity = 'liquidity',
	PanelTrend = 'trend',
	PanelTrendLines = 'trend-lines',
	PanelAdvisor = 'advisor',
	PanelMyTrades = 'my-trades',
	PanelAutoAdvisor = 'auto-advisor',
	PanelMonitor = 'monitor',
	PanelWatchlist = 'watchlist',
	PanelPortfolio = 'portfolio',
	PanelKlimat = 'market-climate',
	PanelConsolidations = 'consolidations',
	PanelPresentations = 'presentations',
	PanelQuant = 'quant',
	PanelSocial = 'social',
	PanelSocialCallback = 'social/callback', // + `/${provider}` — powrót z OAuth platformy
	PanelTrendState = 'trend-state',
	PanelGainsMonitor = 'gains-monitor',
	PanelDailyRange = 'daily-range',
	PanelMarketBottoms = 'market-bottoms',
	PanelOverbalance = 'overbalance',
	PanelEmaStrategy = 'trend-strategies',
	PanelCatchTrend = 'trend-radar',
	PanelQuiz = 'quiz', // + `/${module}`
	PanelPreview = 'preview', // + `/${module}` — teaser for a quiz-unlocked module
	PanelAdmin = 'admin',
	PanelBtcAnalytics = 'btc-analytics',
	PanelOil = 'oil',
	PanelSrZones = 'sr/zones',
	PanelAnalytics360 = 'analytics-360',
	PanelExchangeAccounts = 'exchange/accounts',
	PanelUpgrade = 'upgrade',
	PanelMenu = 'menu',
	PanelAdminUsers = 'admin/users',
	PanelNotifications = 'notifications',
	Offer = 'offer',
	Privacy = 'privacy',
	AccountDeletion = 'account-deletion',
}
